import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShoppingBag, List, X } from "@phosphor-icons/react";

const Header = ({ cartItems = [] }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const count = cartItems.length || JSON.parse(localStorage.getItem("cart") || "[]").length;
    setCartCount(count);
  }, [cartItems]);

  const navLinks = [
    { to: "/products", label: "Printing" },
    { to: "/design-studio", label: "Studio" },
    { to: "/templates", label: "Templates" },
    { to: "/event-packages", label: "Packages" },
    { to: "/my-designs", label: "My Designs" },
  ];

  return (
    <header className="bg-paper border-b-2 border-ink sticky top-0 z-50" data-testid="main-header">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-14">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
            <div className="w-4 h-4 bg-signal border-2 border-ink" />
            <span className="font-archivo text-lg uppercase tracking-tight text-ink">Fit Print Bros</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-0">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className="px-4 py-2 font-mono text-[11px] uppercase tracking-[0.12em] font-medium text-ink hover:bg-ink hover:text-acid transition-colors border-l-2 border-ink"
                data-testid={`nav-${link.to.replace("/", "")}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/concierge-quote" className="px-4 py-2 font-mono text-[11px] uppercase tracking-[0.12em] font-medium bg-signal text-bone border-l-2 border-ink hover:bg-ink hover:text-acid transition-colors" data-testid="nav-quote">
              Get Quote
            </Link>
            <button
              onClick={() => navigate("/cart")}
              className="relative px-4 py-2 border-l-2 border-ink text-ink hover:bg-ink hover:text-acid transition-colors"
              data-testid="cart-button"
            >
              <ShoppingBag weight="bold" className="w-5 h-5" />
              {cartCount > 0 && (
                <span className="absolute top-1 right-1 w-[18px] h-[18px] bg-signal text-bone text-[9px] font-mono font-bold rounded-full flex items-center justify-center border border-ink">
                  {cartCount}
                </span>
              )}
            </button>
          </nav>

          {/* Mobile */}
          <div className="lg:hidden flex items-center gap-0">
            <button
              onClick={() => navigate("/cart")}
              className="relative p-3 border-l-2 border-ink text-ink"
              data-testid="cart-button-mobile"
            >
              <ShoppingBag weight="bold" className="w-5 h-5" />
              {cartCount > 0 && (
                <span className="absolute top-1 right-1 w-[16px] h-[16px] bg-signal text-bone text-[8px] font-mono font-bold rounded-full flex items-center justify-center border border-ink">
                  {cartCount}
                </span>
              )}
            </button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-3 border-l-2 border-ink text-ink"
            >
              {mobileMenuOpen ? <X weight="bold" className="w-5 h-5" /> : <List weight="bold" className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden border-t-2 border-ink bg-bone">
          <nav className="divide-y-2 divide-ink">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className="block px-6 py-3 font-mono text-xs uppercase tracking-[0.12em] font-medium text-ink hover:bg-ink hover:text-acid transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/concierge-quote" className="block px-6 py-3 font-mono text-xs uppercase tracking-[0.12em] font-bold bg-signal text-bone" onClick={() => setMobileMenuOpen(false)}>
              Get Quote
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export { Header };
export default Header;
